import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit {

  @Output() listOpen = new EventEmitter();
  // @Output() alert = new EventEmitter();

  public activeElement = 1;  
  id : number = 1;
  isEditItems: boolean;

  constructor() { }

  ngOnInit() {
  }


  onDelete()
  {
    console.log("value deleted progress");
    alert("do you want delete or not");
    // this.alert.emit(event);
  }

  @Input() details = [];


  onDetail(event)
  {
    console.log("share/detail working");
    this.listOpen.emit(event);
  }



public selectedItem(id) {
    this.activeElement = id;
    this.isEditItems = !this.isEditItems;
 }

}
